import { techColors } from '../styles/TechRetroEffects';

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

export const NOTIFICATION_THEMES = {
  success: {
    color: techColors.success,
    glow: 'subtle',
  },
  info: {
    color: techColors.textPrimary,
    glow: 'subtle',
  },
  warning: {
    color: techColors.textPrimary,
    glow: 'subtle',
  },
  error: {
    color: techColors.danger,
    glow: 'normal',
  },
};

export const getNotificationTheme = (type = NOTIFICATION_TYPES.SUCCESS) => (
  NOTIFICATION_THEMES[type] || NOTIFICATION_THEMES.success
);

export const DEFAULT_NOTIFICATION_DURATIONS = {
  success: 5000,
  info: 10000,
  warning: 10000,
  error: 12000,
};

export const getDefaultDuration = (type) => (
  DEFAULT_NOTIFICATION_DURATIONS[type] ?? 10000
);
